export function formatMoney(cents: number, currency = '金币') {
  const value = cents / 100;
  return `${value.toLocaleString('zh-CN', { minimumFractionDigits: value % 1 ? 2 : 0, maximumFractionDigits: 2 })} ${currency}`;
}

export function currencyInputToCents(value: string) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.round(number * 100) : 0;
}

export function centsToInput(cents: number) {
  return (cents / 100).toFixed(2).replace(/\.00$/, '');
}

export function formatTime(timestamp: number | null | undefined) {
  if (!timestamp) return '—';
  if (new Date(timestamp).getFullYear() === new Date().getFullYear()) return new Intl.DateTimeFormat('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(timestamp));
  return new Intl.DateTimeFormat('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(timestamp));
}

export function localDateTimeValue(timestamp: number) {
  const date = new Date(timestamp - new Date().getTimezoneOffset() * 60_000);
  return date.toISOString().slice(0, 16);
}

export function relativeTime(timestamp: number) {
  const diff = timestamp - Date.now();
  if (diff <= 0) return '已结束';
  const seconds = Math.floor(diff / 1000);
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days) return `${days}天 ${hours}小时`;
  if (hours) return `${hours}小时 ${minutes}分`;
  return `${minutes}分 ${seconds % 60}秒`;
}

export const roleLabel = { member: '成员', admin: '管理员', superadmin: '超级管理员' } as const;
export const statusLabel = { active: '正常', frozen: '已冻结', deleted: '已注销' } as const;

export const commissionStatus = {
  open: { label: '待接单', tone: 'good' },
  taken: { label: '进行中', tone: 'active' },
  submitted: { label: '待确认', tone: 'warn' },
  done: { label: '已完成', tone: 'muted' },
  cancelled: { label: '已取消', tone: 'danger' }
} as const;

export const ledgerKindLabel: Record<string, string> = {
  initial: '初始资金',
  manual_adjustment: '管理员调整',
  commission_escrow: '发布委托冻结',
  commission_refund: '委托退款',
  commission_payment: '委托报酬',
  market_escrow: '购买托管',
  market_purchase: '购买支付',
  market_sale: '卖出收入',
  market_refund: '托管退回',
  transfer_out: '转出',
  transfer_in: '转入',
  deposit: '申领入账',
  withdraw: '兑换冻结',
  withdraw_refund: '兑换退回',
  card_purchase: '购买卡密',
  card_refund: '卡密退款',
  item_exchange: '物品回收',
  appeal_release: '裁决放款',
  appeal_refund: '裁决退款',
  auction_bid: '拍卖出价',
  auction_refund: '出价退回',
  auction_sale: '拍卖成交',
  trade_fee_income: '交易手续费收入',
  checkin_reward: '签到奖励',
  redeem_code: '兑换码'
};

